var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"companyHero"},[_c('picture',[_c('source',{attrs:{"srcset":_vm.getImageSizes('webp'),"sizes":"100vw","type":"image/webp","width":"","height":""}}),_c('img',{attrs:{"src":_vm.getDefaultImage,"alt":"","srcset":_vm.getImageSizes('jpg'),"sizes":"100vw"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }